






























import { listFactory } from '@/main/pages';

import { NAME } from './constants';
import { store } from './store/list';

export default listFactory(NAME, store).extend({
	watch: {
		tableListeners(): {} {
			if (this.table.rows.length) {
				this.table.rows.forEach((row: any) => {
					if (row.cells[this.table!.cellNames!.LEAD_STATUS] === null) {
						row.operations = 1;
					} else {
						row.operations = 0;
					}
				});
			}
			return {
				sideBarSelectRow: this.sideBarSelectRow,
				'save-column-setting': this.saveColumnSetting,
				selectedRow: this.selectedRow,
			};
		},
	},
});
